<template>
  <div class="app-filters">
    <div class="google-map-filter flex flex-col w-full" v-if="$store.state.typeAppFilter === 'map'">
      <div class="flex justify-between mb-8 px30">
        <div class="flex items-center">
          <button v-ripple type="button" class="btn-empty-wrapper mr-5" @click="clickHandler">
            <Close icon="back"></Close>
          </button>
          <span class="font-bold text-16 text-text">{{ $t("Filter") }}</span>
        </div>
        <button type="button" class="map-filter-reset text-14" @click="resetFilter">
          {{ $t("Reset filter") }}
        </button>
      </div>
      <div class="distance-section" v-if="coords.lat && coords.lng">
        <div class="flex justify-between map-filter-headings mb-8 px30">
          <div class="font-bold text-text text-20">
            {{ $t("Distance") }}
          </div>
          <div class="font-bold text-text nearby-item flex flex-nowrap items-center text-20">
            <span>{{ $t("Nearby") }}</span>
            <button type="button" @click="setMyLocation">
              <NearbyIcon />
            </button>
          </div>
        </div>
        <div class="map-filter-miles pt-8">
          <vue-slider v-model="miles" :dot-options="dotOptions" :tooltip-formatter="formatter" :min="0" :max="50"
            :dotSize="22" :height="1" :process="process"></vue-slider>
        </div>
      </div>
      <Discounts v-if="searchType != 'cause'" :data="discounts" :value="discount" title="Discount"
        @select="discount = discount == $event ? '' : $event" />

      <LocationByPricing v-if="searchType != 'cause'" :data="priceList" :value="locationByPricing"
        title="Locations By Pricing" @select="locationByPricing = locationByPricing == $event ? '' : $event" />

      <template v-if="$route.path === '/locations'">
        <div class="open-now-section">
          <div class="flex justify-between map-filter-headings mb-8 px30 items-center">
            <div class=" text-text text-20" :class="{
              'text-cause_text opacity-60': !openNow
            }">
              <label for="openNow">{{ $t("Open Now") }}</label>
            </div>
            <input id="openNow" type="checkbox" class="input-checkbox" v-model="openNow" />
          </div>
        </div>
      </template>
      <div class="flex-grow map-filter-category-container">
        <div class="px30">
          <h3 class="map-filter-title font-bold text-text text-20 mb-8">
            {{ $t("Category") }}
          </h3>
          <ul class="map-filter-category" v-if="categories.length > 0">
            <li class="map-filter-category__item flex justify-between" v-for="item in categories" :key="item.id">
              <label :for="`${item.id}-category-id-${item.id}`" class="map-filter-category__name font-bold text-14"
                :class="{
                  disabled: activeCategory.indexOf(item.id) === -1
                }">
                {{ categoryName(item.name) }}
              </label>
              <span>
                <input :id="`${item.id}-category-id-${item.id}`" type="checkbox" class="input-checkbox"
                  :checked="activeCategory.indexOf(item.id) !== -1" @change="categoryFilterHandler(item.id)" />
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="map-filter-btn px30">
        <Button type="button" :text="$t('Result')" :click-handler="showResult"
          classes="mx-auto table btn-custom"></Button>
      </div>
    </div>

    <div class="cause-filter" v-else-if="
      $store.state.typeAppFilter === 'cause' ||
      $store.state.typeAppFilter === 'partner'
    ">
      <SearchByTitle :back-func="backCauseFunc" :search-title="searchTitle" :search-type="searchType"
        @search-by-title="$emit('search-by-title', $event)"></SearchByTitle>
    </div>

    <template v-else-if="$store.state.typeAppFilter === 'causeSingle'">
      <CauseSingle :click-handler="backCauseFunc" :cause="cause"></CauseSingle>
    </template>

    <template v-else-if="$store.state.typeAppFilter === 'partnerSingle'">
      <PartnerSingle :cause="cause" :click-handler="backCauseFunc"></PartnerSingle>
    </template>
  </div>
</template>

<script>
import Close from "../UI/Close";
import NearbyIcon from "../Icons/NearbyIcon";
import VueSlider from "vue-slider-component";
import Button from "../UI/Button";
import SearchByTitle from "../Cause/SearchByTitle";
import CauseSingle from "../Cause/CauseSingle";
import PartnerSingle from "../Partners/PartnerSingle";
import Discounts from "./Bullets.vue";
import LocationByPricing from "./Bullets.vue";

export default {
  name: "AppFilter",

  components: {
    PartnerSingle,
    CauseSingle,
    Close,
    NearbyIcon,
    VueSlider,
    Button,
    SearchByTitle,
    Discounts,
    LocationByPricing
  },

  props: {
    cause: {
      default: {}
    },
    filterCategory: {
      default: []
    },
    mile: {
      default: 0
    },
    searchTitle: {
      default: ""
    },
    searchType: {
      default: "cause"
    },
    openNowSection: {
      default: false
    },
    lbp: {
      type: [String, Number],
      default: 0
    },
    perk: {
      type: [String, Number],
      default: 0
    }
  },

  data: function () {
    return {
      categories: [],
      activeCategory: [],
      openNow: false,
      miles: [0, 0, 50],
      formatter: "{value} " + this.$t("miles"),
      dotOptions: [
        {
          tooltip: "always",
          disabled: true
        },
        {
          tooltip: "always"
        },
        {
          tooltip: "always",
          disabled: true
        }
      ],
      process: dotsPos => [
        [
          dotsPos[0],
          dotsPos[1],
          {
            // backgroundColor: this.$getState("themes")[this.$getState("theme")]
            backgroundColor: this.bgColor
          }
        ],
        [dotsPos[1], dotsPos[2], { backgroundColor: "#EEF0F2" }]
      ],
      coords: {
        lat: 0,
        lng: 0
      },
      discounts: [10, 15, 20, "25+"],
      priceList: ["$", "$$", "$$$", "$$$$"],
      locationByPricing: 0,
      discount: 0
    };
  },
  mounted() {
    if (this.$getState('corporation')['is']) {
      this.bgColor = this.$getState('corporation')['color_background'];
    }

    if (this.searchType === "cause") {
      this.categories = this.$getState("nposCategories");
    } else {
      this.categories = this.$getState("retailersCategories");
    }
    this.miles = [0, this.mile, 50];
    this.activeCategory = this.filterCategory;
    this.openNow = this.openNowSection;
    this.locationByPricing = this.lbp
    this.discount = this.perk
    this.$setState("isNavigation", false);
    const coords = this.$getState("userLocation");
    this.coords.lat = coords.lat;
    this.coords.lng = coords.lng;
  },

  methods: {
    categoryName: function (jsonStr) {
      let name = "";
      let json = "";
      try {
        json = JSON.parse(jsonStr);
      } catch (e) {
        console.log(e);
      }
      if (!json) return name;

      name =
        json[this.locale] !== undefined
          ? json[this.locale]
          : json["en"] !== undefined
            ? json["en"]
            : "";

      return name;
    },
    backCauseFunc: function () {
      this.$setState("showAppFilters", false);
      this.$setState("typeAppFilter", "map");
      this.$setState("isNavigation", true);
    },
    resetFilter: function () {
      this.miles = [0, 0, 50];
      this.activeCategory = [];
      this.openNow = false;
      this.locationByPricing = 0;
      this.discount = 0;
      this.showResult();
    },
    clickHandler: function () {
      if (!this.$getState("filterWithoutMap")) {
        this.$setState("showGoogleMap", true);
      } else {
        this.$setState("isNavigation", true);
      }
      this.$setState("filterWithoutMap", false);
      this.$setState("showAppFilters", false);
    },
    showResult: function () {
      this.$emit(
        "changeFilterData",
        this.miles["1"],
        this.activeCategory,
        this.openNow,
        this.locationByPricing,
        this.discount
      );
    },
    categoryFilterHandler: function (id) {
      const pos = this.activeCategory.indexOf(id);
      if (pos === -1) {
        this.activeCategory.push(id);
      } else {
        this.activeCategory.splice(pos, 1);
      }
    },
    searchCausesByTitle: function (title, res) {
      this.$emit("searchCausesByTitle", title, res);
    },
    setMyLocation: function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition, function (
          e
        ) {
          console.log("Error.code: " + e.code + " Error.message: " + e.message);
        });
      }
    },
    showPosition: function (position) {
      this.$setState("userLocation", {
        lat: parseFloat(position.coords.latitude),
        lng: parseFloat(position.coords.longitude)
      });
      this.$setState("useUserLocation", true);
      this.$setState("userPlace", "");
    }
  }
};
</script>
